import React from 'react';
import { Instagram, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1A1A1A] pt-8 pb-6 px-4" data-id="element-18">
      {/* Top banner */}
      <div className="max-w-5xl mx-auto text-center mb-8 pb-6 border-b border-white/10" data-id="element-19">
        <p className="text-white font-bold text-sm md:text-base" data-id="element-20">
          MegaPack de Intensificación - Primer Año de Secundaria | Recursos
          Educativos para Docentes
        </p>
      </div>

      {/* Two columns */}
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-21">
        <p className="text-white/60 text-sm" data-id="element-22">
          © 2025 Todos los derechos reservados. InfinitaMente Digital.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-2" data-id="element-23">
          <span className="text-white/60 text-xs" data-id="element-24">Encontranos en:</span>
          <div className="flex items-center gap-3" data-id="element-25">
            <a href="https://instagram.com/infinitamente.digital" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-xs text-white/80 hover:text-white transition-colors" data-id="element-26">
              <Instagram className="w-4 h-4 text-[#E91E63]" data-id="element-27" />
              <span data-id="element-28">@infinitamente.digital</span>
            </a>
            <a href="mailto:soporteinfinitamente@gmail.com" className="flex items-center gap-1.5 text-xs text-white/80 hover:text-white transition-colors" data-id="element-29">
              <Mail className="w-4 h-4 text-[#00BCD4]" data-id="element-30" />
              <span data-id="element-31">soporteinfinitamente@gmail.com</span>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}